const config = {
  env: "local",

  apiUrl: "https://api.antaratalks.com/api/",
  // apiUrl: "http://192.168.0.89:5700/api/",

};

export default config;
